<template>
  <b-form-checkbox-group
    stacked
    size="lg"
    v-model="checkedItems">
    <div class="uncheckable">
      <b-form-checkbox v-for="(item, index) in values" :key="`item-${index}`"
                       :value="`${item}`" class="any" @change="changeCheck">
        <span>{{ $t(item) }}</span>
      </b-form-checkbox>
    </div>

    <b-form-checkbox value="uncheckAll" class="none bottom" @change="uncheckAll"><span>None of the above.</span></b-form-checkbox>
  </b-form-checkbox-group>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: "Checkgroup",
  props: {
    values: {
      type: Array,
      required: true
    },
    storeKey: {
      type: String,
      required: false
    }
  },
  data(){
    return {
      checkedItems: []
    }
  },
  created() {
    if (this.storeKey) {
      var split = this.storeKey.split(".");

      if (this.currentBenchmarks) {
        var benchmark = this.currentBenchmarks.filter(
          function(data) {
            return data.key === split[0];
          }
        );

        var category = benchmark[0].categories.filter(
          function(data) {
            return data.key === split[1];
          }
        )

        this.checkedItems = category[0].checked;
      }
    }
  },
  methods: {
    ...mapMutations(['setCurrentBenchmarks']),
    uncheckAll() {
      this.checkedItems = ["uncheckAll"]
    },
    changeCheck() {
      this.checkedItems = this.checkedItems.filter(e => e !== 'uncheckAll')
    }
  },
  computed: {
    ...mapState(['currentBenchmarks']),
  },
  watch: {
    checkedItems() {
      this.$emit("selected", this.checkedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom {
  position:absolute;
  bottom: 10px;
}
</style>
